import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

function Repetition({ index, data, setData, indexIntervention }) {
  const [errorStartDay, setErrorStartDay] = useState("");
  const handleChange = (e) => {
    const newData = [...data];
    const currentInterventions = [...newData[index].interventions];
    currentInterventions[indexIntervention] = {
      ...currentInterventions[indexIntervention],
      [e.target.name]: e.target.value,
    };

    if (e.target.name === "lastIntervention") {
      if (e.target.value === "no") {
        const isLast = indexIntervention === currentInterventions.length - 1;
        if (isLast) {
          currentInterventions.push({ lastIntervention: "yes" });
        }
      }
      if (e.target.value === "yes") {
        const isLast = indexIntervention === currentInterventions.length - 2;
        const lastItem = currentInterventions[currentInterventions.length - 1];
        if (isLast && Object.keys(lastItem).length <= 1) {
          currentInterventions.pop();
        }
      }
    }


    if (e.target.name === "daysStart") {
      const startDay = parseInt(e.target.value, 10);
      const acclimatation = newData[index].acclimatation;
      const acclimatationDays = parseInt(newData[index].acclimatationDays || "0");
      const preparationDays = parseInt(newData[index].preparationDays || "0");

      let acclimatationEndDay = 0;
      if (acclimatation === "yes" && acclimatationDays > 0) {
        acclimatationEndDay = acclimatationDays;
      }

      let preparationStartDay = acclimatationEndDay > 0 ? acclimatationEndDay + 1 : 1;
      let preparationEndDay = preparationStartDay + (preparationDays > 0 ? preparationDays : 0) - 1;

      const minStartDay = Math.max(acclimatationEndDay, preparationEndDay);

      if (!isNaN(startDay) && startDay <= minStartDay) {
        setErrorStartDay(`The intervention must start after day ${minStartDay}.`);
      } else {
        setErrorStartDay(""); // aucune erreur
      }
    }


    newData[index] = { ...newData[index], interventions: currentInterventions };
    setData(newData);
  };

  const intervention = data[index].interventions[indexIntervention];

  return (
    <div>
      {/* Question - Is this intervention repeated? */}
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="repeatedInterventionLabel">Is this intervention repeated?</InputLabel>
        <Select
          id="repeatedIntervention"
          name="repeatedIntervention"
          label="Is this intervention repeated?"
          value={intervention.repeatedIntervention || ""}
          onChange={handleChange}
        >
          <MenuItem value="no">No</MenuItem>
          <MenuItem value="every_day">Yes, every day for X days</MenuItem>
          <MenuItem value="every_x_days">Yes, every X days for Y times</MenuItem>
          <MenuItem value="after_x_days">Yes, after X days</MenuItem>
        </Select>
      </FormControl>

      {(intervention.repeatedIntervention === "every_day" ||
        intervention.repeatedIntervention === "after_x_days") && (
        <TextField
          id="xDays"
          name="xDays"
          label="Specify X:"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={intervention.xDays || ""}
          onChange={handleChange}
        />
      )}

      {intervention.repeatedIntervention === "every_x_days" && (
        <>
          <TextField
            id="xDays"
            name="xDays"
            label="Specify X:"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={intervention.xDays || ""}
            onChange={handleChange}
          />
          <TextField
            id="yTimes"
            name="yTimes"
            label="Specify Y:"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={intervention.yTimes || ""}
            onChange={handleChange}
          />
        </>
      )}

      {/* Question - What day does this intervention start? */}
      <TextField
        id="daysStart"
        name="daysStart"
        label="What day does this intervention start?"
        variant="outlined"
        fullWidth
        sx={{ mt: 2 }}
        value={intervention.daysStart || ""}
        onChange={handleChange}
        error={!!errorStartDay}
        helperText={errorStartDay}
      />

      {/* Question - Is this the last intervention? */}
      <FormControl>
        <FormLabel id="lastInterventionLabel">Is this the last intervention?</FormLabel>
        <RadioGroup
          aria-labelledby="lastInterventionLabel"
          name="lastIntervention"
          value={intervention.lastIntervention || "yes"}
          onChange={handleChange}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>

    </div>
  );
}

export default Repetition;
